// Portas de entrada das regras. Todas apontam para o MESMO componente
// unificado; o que muda é o `algorithmFilter`, que filtra a listagem e faz o
// formulário renderizar só os campos e ações daquele algoritmo (modo por
// algoritmo — os demais ficam no painel "Avançado" do form).
//
// "Uma tela por algoritmo na percepção, um formulário na implementação":
// telas fisicamente separadas seriam 3 cópias de ~1.000 linhas para divergir
// — a doença que já produziu o 422 do Update/Store e o watcher que perdia
// campos. A rota do balanceamento vive no módulo dele (padrão que estas
// seguem).
const rulesPage = () => import('./pages/RulesIndex')

const crumbs = (...extra) => [
  { text: 'Algoritmos', disabled: true, href: '/' },
  ...extra.map((text) => ({ text, disabled: true, href: '/' })),
]

export default [
  {
    path: '/algoritmos/regras',
    name: 'algorithm-rules-index',
    component: rulesPage,
    meta: {
      title: 'Regras dos algoritmos',
      icon: 'mdi-ruler-square-compass',
      breadcrumbs: crumbs('Regras'),
    },
  },
  {
    path: '/algoritmos/horario/regras',
    name: 'timetable-rules-index',
    component: rulesPage,
    props: { algorithmFilter: 'timetable' },
    meta: {
      title: 'Regras de geração de horários',
      icon: 'mdi-ruler-square-compass',
      breadcrumbs: crumbs('Geração de horários', 'Regras'),
    },
  },
  {
    path: '/algoritmos/ensino-basico/regras',
    name: 'basic-education-rules-index',
    component: rulesPage,
    props: { algorithmFilter: 'basic_education' },
    meta: {
      title: 'Regras do horário do Ensino Básico',
      icon: 'mdi-ruler-square-compass',
      breadcrumbs: crumbs('Ensino Básico', 'Regras'),
    },
  },
  {
    path: '/algoritmos/alocacao/regras',
    name: 'ambience-allocation-rules-index',
    component: rulesPage,
    props: { algorithmFilter: 'ambience_allocation' },
    meta: {
      title: 'Regras de alocação de ambientes',
      icon: 'mdi-ruler-square-compass',
      breadcrumbs: crumbs('Alocação', 'Regras'),
    },
  },
]
